//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import cfr from './cfrList'
    export default{
        name:'christmas_form_three',
        components: {
            cfr
        },
        data(){
            return{
                list_id:'',
                showCfrList:false,
                cfrText:'',
                form:{
                    room:'',
                    hand_card:'',
                    baby_id:'',
                    momName:'',
                    sex:'',
                    momName:'',
                    birth_type:'',
                    record_date:'',
                    record_hour:'',
                    detail:'',
                    agent_id:'',
                    agent_sign:'',
                    shifts:''
                },
                baby_list:[],
                showSignature:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
                get_host:host.host
            }
        },
        created(){
            this.get_baby_list()
            this.apiMemberInfo()
            if(this.$route.query.list_id){
                this.apiGetCfrList()
            }
        },
        methods:{
            //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.momName = res.data.name
                        this.form.room = res.data.room_name
                        this.form.birth_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : ''
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //获取宝宝
            get_baby_list (){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.monthLiveApi.babyList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.baby_list = res.data
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //选择宝宝
            checkerChange(value){
                for(let item of this.baby_list){
                    if(item.id == value){
                        if(item.live_time == '0'){
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name+'暂未入住',
                            })
                            return
                        }
                        this.form.hand_card = item.hand_card
                        this.form.sex = item.sex == '1' ? '男' : '女'
                    }
                }
            },
            apiGetCfrList(){
                let params = {
                    token: this.$cookie.get('token'),
                    store_id:this.$cookie.get('store_id'),
                }
                Api.checkRoomApi.getCheckInfo(params).then ( res => {
                    console.info("获取查房人列表",res)
                    if(res.errcode == 1){
                        this.nurser_name = res.data.nurser_name//过滤了离院，
                        this.apiDetail(res.data.nurser_name)
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        }) 
                    }
                })
            },
             //点击选择查房人
            selectPeople(){
                this.showCfrList = true
            },
            //赋值查房人ID
            cfrListEven(val,item){
                this.showCfrList = val
                if(item){
                    this.form.agent_id = item.id
                    this.cfrText = item.user_name
                }
            },
            save(){
                let signature ='signature1'
                let png = this.$refs[signature].save()
                this.form.agent_sign = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
                this.form.agent_sign = ''
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.agent_sign = ''
            },
            //请求详情数据
            apiDetail(name){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.chritmasFormApi.getBabySpecialNursingRecord(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        this.form.room = data.room
                        this.form.hand_card = data.hand_card
                        this.form.baby_id = data.baby_id
                        this.form.record_date=data.record_date,
                        this.form.record_hour=data.record_hour,
                        this.form.detail=data.detail,
                        this.form.agent_id=data.agent_id,
                        this.form.agent_sign=data.agent_sign.indexOf(this.get_host) != -1 ? data.agent_sign : this.get_host+data.agent_sign
                        this.form.shifts=data.shifts
                        if(name.length){
                            for(let item of name){
                                if(item.id == data.agent_id){
                                    this.cfrText = item.user_name
                                }
                            }
                        }
                        this.showSignature = true
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    room:this.form.room,
                    hand_card:this.form.hand_card,
                    baby_id:this.form.baby_id,
                    record_date:this.form.record_date,
                    record_hour:this.form.record_hour,
                    detail:this.form.detail,
                    agent_id:this.form.agent_id,
                    agent_sign:this.form.agent_sign,
                    shifts:this.form.shifts
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.chritmasFormApi.addBabySpecialNursingRecord(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'christmas_form_four',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求更新数据
            apiUpdateForm(){
                let params = {
                    id:this.$route.query.list_id,
                    token: this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    room:this.form.room,
                    hand_card:this.form.hand_card,
                    baby_id:this.form.baby_id,
                    record_date:this.form.record_date,
                    record_hour:this.form.record_hour,
                    detail:this.form.detail,
                    agent_id:this.form.agent_id,
                    agent_sign:this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host,'') : this.form.agent_sign,
                    shifts:this.form.shifts
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.chritmasFormApi.updateBabySpecialNursingRecord(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'christmas_form_four',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            submitForm(){
                // 判断宝宝是否入住
                let time = 0
                if(this.baby_list.length){
                    for(let item of this.baby_list){
                        if(item.id == this.form.baby_id){
                            time = item.live_time
                        }
                    }
                }
                if(time == '0'){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '该宝宝暂未入住',
                    })
                    return
                }
                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    this.apiAddForm()
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/christmas_form_four.vue